// extracted by mini-css-extract-plugin
export default {"footer":"GlobalFooter_footer__aKht5","footerText":"GlobalFooter_footerText__Wv-Dx"};